export default __webpack_public_path__ + "static/tim-bitmoji-35954255cb1f0b118a6ed743b1fc3c2e.png";